import requestService from '../requestService';
import store from '@/store';
//import router from '../../router'

export default {
	async getBusinessTypes() {
		try {
			const response = await requestService.get('/business_type?lang=' + store.getters.loggedUser.locale, {
				headers: { Authorization: `Bearer ${store.getters.loggedUser.token}` }
			})
			return response?.data
		}
		catch {
			// store.commit("clearUserLogged");
			// router.push('/login')
		}
	},
	async getBusinessCategories() {
		try {
			const response = await requestService.get('/business_category?lang=' + (store.getters.loggedUser ?  store.getters.loggedUser.locale : store.getters.user.locale))
			return response?.data
		}
		catch {
			// store.commit("clearUserLogged");
			// router.push('/login')
		}
	},
	async getBusinessSubcategories(category) {
		try {
			const response = await requestService.get('/business_category/' + category + '?lang=' + (store.getters.loggedUser ?  store.getters.loggedUser.locale : store.getters.user.locale))
			return response?.data
		}
		catch {
			// store.commit("clearUserLogged");
			// router.push('/login')
		}
	},
	async getSocialTypes() {
		try {
			const response = await requestService.get('/social_type?lang=' + store.getters.loggedUser.locale, {
				headers: { Authorization: `Bearer ${store.getters.loggedUser.token}` }
			})
			return response?.data
		}
		catch {
			// store.commit("clearUserLogged");
			// router.push('/login')
		}
	},
	async getNeighbourhood() {
		try {
			const response = await requestService.get(`/neighbourhood?lang=` + (store.getters.loggedUser ?  store.getters.loggedUser.locale : store.getters.user.locale))
			return response?.data
		}
		catch {
			// store.commit("clearUserLogged");
			// router.push('/login')
		}
	},
	async getMunicipalities() {
		try {
			const response = await requestService.get(`/municipality`)
			return response?.data
		}
		catch {
			// store.commit("clearUserLogged");
			// router.push('/login')
		}
	},
	async getDevices() {
		try {
			const response = await requestService.get(`/device_access?lang=` + store.getters.loggedUser, {
				headers: { Authorization: `Bearer ${store.getters.loggedUser.token}` }
			})
			return response?.data
		}
		catch {
			// store.commit("clearUserLogged");
			// router.push('/login')
		}
	},
	async getBusinessSizes() {
		try {
			let response = null
			if (process.env.VUE_APP_TYPE == "Business") {
				response = await requestService.get(`/business_size`, {
					headers: { Authorization: `Bearer ${store.getters.loggedUser.token}` }
				})
			}
			else {
				response = await requestService.get(`/organisation_size`, {
					headers: { Authorization: `Bearer ${store.getters.loggedUser.token}` }
				})
			}
			return response?.data
		}
		catch {
			// store.commit("clearUserLogged");
			// router.push('/login')
		}
	},
};